<template>
  <div class="comp-node-info">
    <div class="node-info-top">
      <div class="icon-circle" :style="{ backgroundColor: getBackgroundColor(nodeInfo?.data?.status) }"></div>
      <div class="node-info-content">{{ nodeInfo?.data?.label }}</div>
      <div v-if="nodeInfo?.data?.status == 5" class="node-tag"><jw-tag size="small" color="green">已完成</jw-tag></div>
      <div v-if="nodeInfo?.data?.status == 1" class="node-tag"><jw-tag size="small" color="orange">进行中</jw-tag></div>
      <div v-if="nodeInfo?.data?.status == 0" class="node-tag"><jw-tag size="small">未开始</jw-tag></div>
    </div>
    <div class="node-info-time" v-if="startTime || endTime || execTime">
      <div class="node-info-item">
        <div class="node-info-item-title">开始时间</div>
        <div class="node-time">{{ startTime }}</div>
      </div>
      <div class="node-info-item" style="margin-right: 16px; margin-left: 16px">
        <div class="node-info-item-title">完成时间</div>
        <div class="node-time">{{ endTime ? endTime : '---' }}</div>
      </div>
      <div class="node-info-item">
        <div class="node-info-item-title">进行时间</div>
        <div class="node-time">{{ execTime }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
// import { tools } from '@/utils/tools.js';
import { computed } from 'vue';
const props = defineProps({
  mouseNodeInfo: {
    type: [Object],
    default: () => {}
  }
});
const nodeInfo = computed(() => props.mouseNodeInfo);
const startTime = computed(() => (props.mouseNodeInfo?.data?.startTime ? props.mouseNodeInfo?.data?.startTime : ''));
const endTime = computed(() => (props.mouseNodeInfo?.data?.endTime ? props.mouseNodeInfo?.data?.endTime : ''));
const execTime = computed(() => (props.mouseNodeInfo?.data?.execTime ? props.mouseNodeInfo?.data?.execTime : ''));
console.log('startTime', startTime, endTime);
const getBackgroundColor = (status) => {
  if (status == 5) return `rgb(var(--success-4))`;
  if (status == 1) return `rgb(var(--orange-4))`;
  if (status == 0) return `var(--color-border-4)`;
};
</script>
<style scoped lang="less">
@import './node-info.less';
</style>
